<template>
    <div class="row section-row">
      <div class="col-lg-12 row-background-color">
        <div class="row table-head-row-background-color non-mobile-admin-table">
          <div style="width: 10%">Vessel</div>
          <div style="width: 15%">Issued At</div>
          <!-- <div style="width: 10%">Port</div> -->
          <div style="width: 15%">Date From</div>
          <div style="width: 15%">Date To</div>
          <!-- <div style="width: 15%">Valid Date</div> -->
          <div style="width: 15%">Officer</div>
          <div style="width: 10%"> Rating</div>
     
          <div style="width: 10%">Print</div>
          <div style="width: 10%">Delete</div>
        </div>
  
  
        <div class="row table-head-row-background-color mobile-admin-table">
          <div style="width: 16%">Vessel</div>
          <!-- <div style="width: 10%">Issued At</div>
          <div style="width: 10%">Port</div> -->
          <div style="width: 16%">Date From</div>
          <div style="width: 16%">Date To</div>
          <!-- <div style="width: 15%">Valid Date</div> -->
          <div style="width: 18%">Officer</div>
          <div style="width: 10%"> Rating</div>
     
          <div style="width: 10%">Print</div>
          <div style="width: 14%">Delete</div>
        </div>
  
        <!-- <ReportRow v-bind:row="report" @changedSelect="selectedRow" @deleteSelect="deletedRow" /> -->
  
      <div v-if="this.reports.length>0">
         <div
            v-for="report in reports.slice(this.queryStart, this.queryEnd)"
            :key="report.Id"
          >
  
         <ReportsRow v-bind:row="report" @changedSelect="selectedRow" @deleteSelect="deletedRow" />
        </div> 
  
        <TableMenu
          v-bind:reports="this.reports"
          @changedSelect="changePageSelection"
        />
      </div>
  
  
  
    </div>
    </div>
  </template>
  
  <script>
  import ReportsRow from "./ReportsRow";
  import TableMenu from "./TableMenu.vue";
  export default {
    name: "ReportsTable",
    props: ["reports"],
    components: {
      ReportsRow,
      TableMenu,
    },
    data() {
      return {
        name: "AdministrationTable",
        queryStart: 0,
        queryEnd: 10,
      };
    },
    methods: {
      selectedRow: function (value) {
        this.$emit("changedSelect", value);
      },
      deletedRow: function (value) {
        this.$emit("deletedSelect", value);
      },
      changePageSelection: function (value) {
        // alert("value"+JSON.stringify(value));
        this.queryStart = value.start;
        this.queryEnd = value.end;
      },
    },
  };
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  </style>
  